import { makeStyles } from '@mui/styles'
import { MenuIcon } from 'genesis-suite/components'
import { ExportAsPDF } from 'genesis-suite/icons'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { perspectiveSelectors } from '~/selectors'
import tadaWatermark from '../assets/img/tada-watermark.png'
import ReactToPrint from 'react-to-print'

const useStyles = makeStyles(() => ({
    backdrop: { cursor: 'not-allowed' },
    waterMark: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: '0.2',
        width: '30%',
        zIndex: '999999',
    },
    displayAll: {
        overflow: 'visible !important',
    },
}))

export default function PerspectiveExport({ disabled, iconProps, buttonStyle }) {
    const title = useSelector(perspectiveSelectors.getTitle)
    const classes = useStyles()
    const printContent = useRef(null)

    useEffect(() => {
        const container = document.getElementById('perspective-container')

        if (container) {
            printContent.current = container
        }
    }, [])

    const customToPrint = printWindow => {
        const printContent = printWindow.contentDocument || printWindow.contentWindow?.document
        const printedPerspectiveContainer = printContent.getElementById('perspective-container')
        const printedPerspectiveLayout = printContent.getElementById('perspective-layout')
        const perspectiveWidgets = printedPerspectiveContainer.querySelector('.widget-parent-wrapper')
        const filterString = printContent.getElementById('filter-string')
        const formSwitch = printContent.getElementById('formSwitch')
        const perspectiveToolbar = printContent.getElementById('perspective-toolbar')
        const perspectiveSearch = printContent.getElementById('perspective-search')

        if (printContent && !document.getElementById('pdf-watermark')) {
            printedPerspectiveContainer.style.position = 'relative'
            const watermark = document.createElement('img')
            watermark.id = 'pdf-watermark'
            watermark.src = tadaWatermark
            Object.assign(watermark.style, {
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                opacity: '0.2',
                width: '30%',
                zIndex: '999999',
            })

            printedPerspectiveContainer.appendChild(watermark)
        }

        const widgetsHeight = perspectiveWidgets.scrollHeight + 200
        const width = perspectiveWidgets.scrollWidth

        printedPerspectiveLayout.style.overflow = 'visible !important'
        printedPerspectiveContainer.style.height = `${widgetsHeight}px`
        printedPerspectiveContainer.style.width = `${width}px`

        if (filterString) filterString.style.display = filterString && 'none'
        if (formSwitch) formSwitch.style.display = formSwitch && 'none'
        if (perspectiveSearch) perspectiveSearch.style.display = 'none'
        if (perspectiveToolbar) perspectiveToolbar.style.display = 'none'

        printWindow.contentWindow.print()

        return Promise.resolve()
    }

    return (
        <>
            <ReactToPrint
                bodyClass={classes.displayAll}
                trigger={() => (
                    <MenuIcon
                        buttonProps={{ sx: buttonStyle }}
                        closeButton
                        icon={<ExportAsPDF {...iconProps} />}
                        disabled={disabled}
                        title="Export as PDF"
                        tooltip="Export perspective as pdf"
                    ></MenuIcon>
                )}
                print={customToPrint}
                content={() => printContent.current}
                documentTitle={title}
            />
        </>
    )
}
